import { DecryptedItemMutator } from '@standardnotes/models';
export class KeySystemItemsKeyMutator extends DecryptedItemMutator {
}
